@if (logement$ | async; as logement) {
  <section class="container-background container-fluid content">
    @if (currentNode) {
      <div class="row">
        <h2 class="page-title col-12">
          <div class="d-flex align-items-start">
            <div class="flex-grow-1">
              Documents
            </div>
            @if (currentNode.writable ||  isProprietaire(logement)) {
              <span ngbDropdown placement="bottom-right">
                @if (logement.isOpen() || isProprietaire(logement)) {
                  <button class="btn btn-blue btn-lg" ngbDropdownToggle>
                    <fa-icon [icon]="faCog"></fa-icon>Actions
                  </button>
                }
                <div ngbDropdownMenu>
                  @if (isProprietaire(logement) && documentSharings?.length > 0) {
                    <button ngbDropdownItem
                      (click)="open(content);">
                      <fa-icon [icon]="faList"></fa-icon>
                      Historique de partage
                    </button>
                  }
                  @if (isProprietaire(logement)) {
                    <button ngbDropdownItem  routerLink="/partage-document">
                      <fa-icon [icon]="faShareAlt"></fa-icon>
                      Partager/Recevoir des documents
                    </button>
                  }
                  @if (currentNode.addFolders && currentNode.writable) {
                    <button ngbDropdownItem
                      (click)="resetForm();modalService.open(createOrRenameNodeModal)">
                      <fa-icon [icon]="faFolder"></fa-icon> Ajouter
                      Nouveau dossier
                    </button>
                  }
                  @if (currentNode.writable) {
                    <button ngbDropdownItem ngfSelect [(files)]="files" multiple="true"
                      (click)="resetUpload()"
                      (filesChange)="openUploadModal()">
                      <fa-icon [icon]="faPlus"></fa-icon> Importer des fichiers
                    </button>
                  }
                </div>
              </span>
            }
          </div>
        </h2>
      </div>
      <div class="m-2 p-4 bg-white rounded">
        <div class="alert alert-warning" role="alert">
          CIL : documents obligatoires dans le cadre du Carnet d'Information du Logement (disponibles dans Logement)
        </div>
        <div class="container-fluid">
          <div class="row mb-3 d-none d-lg-block">
            <app-breadcrumb [crumbs]="breadcrumbs"></app-breadcrumb>
          </div>
          @if (!currentNode.root) {
            <app-row-item title=".." class="cursor-pointer" routerLink="..">
              <ng-container prepend>
                <fa-icon [icon]="faLevelUpAlt" size="lg" class="check me-3"></fa-icon>
              </ng-container>
            </app-row-item>
          }
          @if (currentNode.children.length > 0) {
            @for (child of currentNode.children; track child) {
              <app-row-item [title]="child.name" [child]="child" class="cursor-pointer"
                (rowClick)="goTo(child)">
                <ng-container prepend>
                  <app-file-icon class="me-3" [path]="child.type == NodeType.FILE ? $safeNavigationMigration(child.document.fichier?.url) : 'folder'"></app-file-icon>
                </ng-container>
                <ng-container actions>
                  <button ngbDropdownItem (click)="goTo(child)">Ouvrir</button>
                  @if (logement.isOpen() && child.editable && !child.isDocumentLogement && !child.isDocumentResidence && !child.isDocumentCarnet) {
                    @if (child.editable) {
                      <button ngbDropdownItem
                        (click)="populateForm(child);modalService.open(createOrRenameNodeModal)">Renommer
                      </button>
                    }
                    @if (child.editable && child?.type == NodeType.FOLDER) {
                      <button ngbDropdownItem
                        (click)="populateForm(child);modalService.open(moveNodeModal)">Déplacer
                      </button>
                    }
                    @if (child.editable && child?.type == NodeType.FILE) {
                      <button ngbDropdownItem
                        (click)="openMoveFromLogement(child, updateDocumentPersoModal)">
                        Déplacer
                      </button>
                    }
                    @if (child.editable) {
                      <app-delete-confirm (opened)="populateForm(child)" (deleted)="deleteNode()" [message]="'Confirmez-vous la suppression de ce '+ (nodeType == NodeType.FOLDER ? 'dossier et de tout son contenu' : 'fichier') + '?'">
                        <button ngbDropdownItem>Supprimer</button>
                      </app-delete-confirm>
                    }
                  }
                  @if (!child.editable && (child.isDocumentLogement || child.isDocumentCarnet) && !child.isDocumentResidence && child?.type == NodeType.FILE && child.document.dossier == null) {
                    <button ngbDropdownItem
                      (click)="populateForm(child);modalService.open(RenameNodeResidenceLogement)">Renommer
                    </button>
                  }
                  @if (currentNode.isDocumentLogement) {
                    <button ngbDropdownItem
                      (click)="openMoveFromLogement(child, updateDocumentObligatoireModal)">Déplacer
                    </button>
                  }
                  @if (child.deletable) {
                    @if (child.deletable && !child.isDocumentResidence) {
                      <app-delete-confirm (opened)="populateForm(child)" (deleted)="deleteDocumentCarnet()" [message]="'Confirmez-vous la suppression de ce '+ (nodeType == NodeType.FOLDER ? 'dossier et de tout son contenu' : 'fichier') + '?'">
                        <button ngbDropdownItem>Supprimer</button>
                      </app-delete-confirm>
                    }
                  }
                  @if (logement.isOpen() && userService.isLocataire(logement) && child.type === 'FILE') {
                    @if (child.canShare && child.document && !child.document.roles.includes('ROLE_COPROPRIETAIRE')) {
                      <app-open-locataire-confirm (deleted)="addRoleProprietaire(child)" [message]="'Confirmez-vous l\'ouverture de ce document au propriétaire ?'">
                        <button ngbDropdownItem>Ouvrir au propriétaire</button>
                      </app-open-locataire-confirm>
                    }
                    @if (child.canShare && child.document && child.document.roles.includes('ROLE_COPROPRIETAIRE')) {
                      <app-open-locataire-confirm (deleted)="removeRoleProprietaire(child)" [message]="'Confirmez-vous la fermeture de ce document au propriétaire ?'" [title]="'Confirmation de fermeture'">
                        <button ngbDropdownItem>Fermer au propriétaire</button>
                      </app-open-locataire-confirm>
                    }
                  }
                  @if (logement.isOpen() && userService.isProprietaire(logement) && child.type === 'FILE' && logementService.hasLocataires(logement)) {
                    @if (canOpenToLocataire(child)) {
                      <app-open-locataire-confirm (deleted)="addRoleLocataire(child)" [message]="'Confirmez-vous l\'ouverture de ce document au(x) locataire(s) ?'">
                        <button ngbDropdownItem>Ouvrir au(x) locataire(s)</button>
                      </app-open-locataire-confirm>
                    }
                    @if (!canOpenToLocataire(child)) {
                      <app-open-locataire-confirm (deleted)="removeRoleLocataire(child)"  [message]="'Confirmez-vous la fermeture de ce document au(x) locataire(s) ?'" [title]="'Confirmation de fermeture'">
                        <button ngbDropdownItem>Fermer au(x) locataire(s)</button>
                      </app-open-locataire-confirm>
                    }
                  }
                </ng-container>
              </app-row-item>
            }
          } @else {
            <div class="row">
              @if (files.length > 0) {
                <div class="col-12 alert alert-info">
                  {{ currentNode.writable && currentNode.deep == 1 ? 'Rangez ici tous les documents de votre logement (plans, assurances, travaux, factures, …) en cliquant sur Actions / Importer des fichiers.' : 'Ce dossier est vide.'}}
                </div>
              }
            </div>
          }
          <ng-template #emptyFolder>
            <div class="row">
              @if (files.length > 0) {
                <div class="col-12 alert alert-info">
                  {{ currentNode.writable && currentNode.deep == 1 ? 'Rangez ici tous les documents de votre logement (plans, assurances, travaux, factures, …) en cliquant sur Actions / Importer des fichiers.' : 'Ce dossier est vide.'}}
                </div>
              }
            </div>
          </ng-template>
        </div>
      </div>
    }
  </section>
}

<!--Modal de création renommage-->
<ng-template #createOrRenameNodeModal let-modal>
  <form [formGroup]="form" (ngSubmit)="createOrRenameOrMoveNode();modal.close()">
    <div class="modal-header">
      <h4 class="modal-title">{{ nodeType == NodeType.FOLDER ? ( nodeId ? 'Renommer le fichier' : 'Nouveau dossier') : 'Renommer le fichier'}}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        @if (form.get('nom'); as control) {
          <div class="mb-3 col-12">
            <input class="form-control" type="text" formControlName="nom" [ngClass]="{'is-invalid': !control.valid}"
              (focus)="$event.target.select()">
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss();">Annuler</button>
      <button type="submit" class="btn btn-blue"
      [disabled]="nodeName.trim() === ''">{{ nodeId ? 'Renommer' : 'Créer' }}</button>
    </div>
  </form>
</ng-template>

<ng-template #RenameNodeResidenceLogement let-modal>
  <form [formGroup]="form" (ngSubmit)="renameNodeResidenceLogement();modal.close()">
    <div class="modal-header">
      <h4 class="modal-title">Renommer le fichier</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        @if (form.get('nom'); as control) {
          <div class="mb-3 col-12">
            <input class="form-control" type="text" formControlName="nom" [ngClass]="{'is-invalid': !control.valid}"
              (focus)="$event.target.select()">
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss();">Annuler</button>
      <button type="submit" class="btn btn-blue"
      [disabled]="nodeName.trim() === ''">Renommer</button>
    </div>
  </form>
</ng-template>

<!--Modal de déplacement-->
<ng-template #moveNodeModal let-modal>
  <form [formGroup]="form" (ngSubmit)="createOrRenameOrMoveNode();modal.close()">
    <div class="modal-header">
      <h4 class="modal-title">{{moveTargetCurrentNode.name}}</h4>
    </div>
    <div class="modal-body modal-body-max-vh">
      <div class="container-fluid">
        @if (!moveTargetCurrentNode.root) {
          <app-row-item title=".." class="cursor-pointer"
            (rowClick)="navigateTargetParent(moveTargetCurrentNode.path)">
            <ng-container prepend>
              <fa-icon [icon]="faLevelUpAlt" size="lg" class="check me-3"></fa-icon>
            </ng-container>
          </app-row-item>
        }
        @for (child of moveTargetCurrentNode.children; track child) {
          <app-row-item [title]="child.name" class="cursor-pointer"
            [ngClass]="{'disabled' : !isPossibleTarget(child)}"
            (rowClick)="isPossibleTarget(child) ? navigateTarget(child.path) : null">
            <ng-container prepend>
              <app-file-icon class="me-3" [path]="child.type == NodeType.FILE ? child.document.fichier.url : 'folder'"></app-file-icon>
            </ng-container>
          </app-row-item>
        }
      </div>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss();">Annuler</button>
      <button type="submit" class="btn btn-blue"
        [disabled]="moveTargetCurrentNode.root || moveTargetCurrentNode == currentNode">Déplacer
      </button>
    </div>
  </form>
</ng-template>

<!--Modal de déplacement-->
<ng-template #updateDocumentObligatoireModal let-modal>

  <form (ngSubmit)="updateDocumentObligatoire(activeDocumentId);modal.close()">

    <div class="modal-header">
      <h4 class="modal-title">
        {{ moveTargetCurrentNodeFiltered?.name || 'Déplacer' }}
      </h4>
    </div>

    <div class="modal-body modal-body-max-vh">
      <div class="container-fluid">

        <!-- RACINE -->

        @if (isMoveRootFiltered) {
          @for (node of moveRootNodes; track node) {
            <app-row-item
              [title]="node.name"
              class="cursor-pointer"
              (rowClick)="navigateTargetFiltered(node.path)">
              <ng-container prepend>
                <app-file-icon class="me-3" path="folder"></app-file-icon>
              </ng-container>
            </app-row-item>
          }
        }

        <!-- NAVIGATION -->

        @if (!isMoveRootFiltered && moveTargetCurrentNodeFiltered) {
          <app-row-item
            title=".."
            class="cursor-pointer"
            (rowClick)="navigateTargetParentFiltered(moveTargetCurrentNodeFiltered.path)">
            <ng-container prepend>
              <fa-icon [icon]="faLevelUpAlt" class="me-3"></fa-icon>
            </ng-container>
          </app-row-item>
          @for (child of moveTargetCurrentNodeFiltered.children; track child) {
            @if (child.type === NodeType.FOLDER) {
              <app-row-item
                [title]="child.name"
                class="cursor-pointer"
                [ngClass]="{'disabled': isSameFolder(child)}"
                (rowClick)="!isSameFolder(child) ? selectTargetFolder(child) : null">
                <ng-container prepend>
                  <app-file-icon class="me-3" path="folder"></app-file-icon>
                </ng-container>
              </app-row-item>
            }
          }
        }

      </div>
    </div>

    <div class="modal-footer">

      <button type="button" class="btn btn-light" (click)="modal.dismiss()">
        Annuler
      </button>

      <button type="submit" class="btn btn-blue" [disabled]="!isValidMoveTarget()">
        Déplacer
      </button>

    </div>

  </form>

</ng-template>

<ng-template #updateDocumentPersoModal let-modal>

  <form (ngSubmit)="movePersonalDocument(modal)">

    <div class="modal-header">
      <h4 class="modal-title">
        {{ moveTargetCurrentNodeFiltered?.name || 'Déplacer' }}
      </h4>
    </div>

    <div class="modal-body modal-body-max-vh">
      <div class="container-fluid">

        <!-- RACINE -->

        @if (isMoveRootFiltered) {
          @for (node of moveRootNodes; track node) {
            <app-row-item
              [title]="node.name"
              class="cursor-pointer"
              (rowClick)="navigateTargetFiltered(node.path)">
              <ng-container prepend>
                <app-file-icon class="me-3" path="folder"></app-file-icon>
              </ng-container>
            </app-row-item>
          }
        }

        <!-- NAVIGATION -->

        @if (!isMoveRootFiltered && moveTargetCurrentNodeFiltered) {
          <app-row-item
            title=".."
            class="cursor-pointer"
            (rowClick)="navigateTargetParentFiltered(moveTargetCurrentNodeFiltered.path)">
            <ng-container prepend>
              <fa-icon [icon]="faLevelUpAlt" class="me-3"></fa-icon>
            </ng-container>
          </app-row-item>
          @for (child of moveTargetCurrentNodeFiltered.children; track child) {
            @if (child.type === NodeType.FOLDER) {
              <app-row-item
                [title]="child.name"
                class="cursor-pointer"
                [ngClass]="{'disabled': isSameFolder(child)}"
                (rowClick)="!isSameFolder(child) ? selectTargetFolder(child) : null">
                <ng-container prepend>
                  <app-file-icon class="me-3" path="folder"></app-file-icon>
                </ng-container>
              </app-row-item>
            }
          }
        }

      </div>
    </div>

    <div class="modal-footer">

      <button type="button" class="btn btn-light" (click)="modal.dismiss()">
        Annuler
      </button>

      <button type="submit" class="btn btn-blue" [disabled]="!isValidMoveTarget()">
        Déplacer
      </button>

    </div>

  </form>

</ng-template>



<!--Modal d'upload-->
<ng-template #uploadModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Importer des fichiers</h4>
  </div>
  <div class="modal-body modal-body-max-vh" ngbAutofocus>
    @if (hasFileTooLarge) {
      <div class="alert alert-warning" role="alert">
        Attention! Vous avez un ou plusieurs fichiers trop volumineux. La limite d'upload des fichiers est de 30MB.
      </div>
    }
    @if (hasFileExtentionNotSupported) {
      <div class="alert alert-warning" role="alert">
        Attention! Vous avez un ou plusieurs fichiers qui n'ont pas la bonne extension ('jpg', 'png', 'jpeg', 'jfif', 'gif', 'bmp', 'svg', 'txt', 'pdf', 'doc', 'docx', 'xml','xls','xlsx').
      </div>
    }
    <ngfFormData
      [files]="files"
      [(FormData)]="filesData"
      postName="documents[]"
    ></ngfFormData>
    <table class="table table-sm table-borderless">
      <tbody>
        @for (item of files; track item; let i = $index) {
          <tr>
            <td>{{ item.name }} ( {{item.size | filesize}} )</td>
            <td class="text-end">
              @if (!uploadProgress) {
                <button type="button" class="btn btn-light btn-xs" (click)="files.splice(i,1); updateHasFileTooLarge(); updateHasFileExtensionNotSupported()"
                  >
                  <fa-icon [icon]="faTrashAlt"></fa-icon>
                </button>
              } @else {
                @if (getProgressPercent(item); as progress) {
                  <circle-progress [percent]="progress" [imageSrc]="progress == 100 ? '/assets-front/images/upload-done.svg' : ''"></circle-progress>
                }
              }
              <ng-template #uploadInProgress>
                @if (getProgressPercent(item); as progress) {
                  <circle-progress [percent]="progress" [imageSrc]="progress == 100 ? '/assets-front/images/upload-done.svg' : ''"></circle-progress>
                }
              </ng-template>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-blue" (click)="uploadFiles(modal)" [disabled]="uploadProgress || hasFileTooLarge || hasFileExtentionNotSupported">Importer
    </button>
  </div>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Historique de partage</h4>
    <button type="button" class="btn btn-light" aria-label="Close" (click)="modal.dismiss()"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formSharing">
      <div class="row">
        <div class="d-none d-sm-flex col-sm-7 text-center fw-bold">Tiers</div>
        <div class="d-none d-sm-flex col-sm-3 text-center fw-bold">Fin de validité</div>
        <div class="d-none d-sm-flex col-sm-2 text-center fw-bold">Action</div>
        @for (documentSharing of documentSharings; track documentSharing) {
          <ng-container class="row">
            <div class="col-sm-7">
              <ul>
                @for (recipient of documentSharing.recipients; track recipient) {
                  <li class="text-truncate">{{ recipient }}</li>
                }
                @for (document of documentSharing.documents; track document) {
                  <ul>
                    <li class="text-truncate">
                      {{ document.nom }} -
                      Partagé par	 {{ document.sharing_signature ? document.sharing_signature : documentSharing.user.nom + ' ' + documentSharing.user.prenom }}
                    </li>
                  </ul>
                }
                @for (mesDocuments of documentSharing.mesDocuments; track mesDocuments) {
                  <ul>
                    <li class="text-truncate">
                      {{ mesDocuments.nom }} -
                      Partagé par	  {{documentSharing?.user.nom}} {{documentSharing?.user.prenom }}
                    </li>
                  </ul>
                }
              </ul>
            </div>
            <div class="col-sm-2">
              <input
                type="date"
                class="form-control"
                placeholder="Date de validité"
                formControlName="expirationDate_{{documentSharing.id}}"
                />
            </div>
            <div class="col-sm-1 text-center">
              @if (documentSharing.id) {
                <app-delete-confirm (deleted)="deleteDocumentSharing(documentSharing)" [message]="'Confirmez-vous la suppression de ce partage ?'">
                  <fa-icon class="custom-icon" [icon]="faTrashAlt"></fa-icon> <span class="d-sm-none">Supprimer</span>
                </app-delete-confirm>
              }
            </div>
          </ng-container>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-orange" (click)="modal.dismiss()">Fermer</button>
        <button type="button" class="btn-submit btn btn-blue" (click)="onSubmit(modal)" [disabled]="form.invalid">Enregistrer</button>
      </div>
    </form>
  </div>
</ng-template>
